import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import EstimationStore from '../libs/EstimationStore'
import EstimationActions from '../libs/EstimationActions'

let currentEditingElementDataName = 'currentEditingElement'

class OneLineEditor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      textAlign: this.props.textAlign,
      bindingDataAttribute: this.props.bindingDataAttribute,
      data: this.props.getData(),
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: this.props.getData()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }

  getDataValue () {
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      let value = this.state.data[listName][index][this.state.bindingDataAttribute]
      if (this.props.isNum && !isFinite(value)) {
        return ''
      }
      return value
    }
    let value = this.state.data[this.state.bindingDataAttribute]
    if (this.props.isNum && (!isFinite(value) || (value == null))) {
      return ''
    }
    return value
  }
  enterEditingMode () {
    if (!EstimationActions.getEditableMode()) return
    if (!this.props.isEditable) return
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      EstimationActions.update(currentEditingElementDataName, listName + index + this.props.bindingDataAttribute + this.props.viewListId)
    } else {
      EstimationActions.update(currentEditingElementDataName, this.state.bindingDataAttribute)
    }
  }
  exitEditingMode () {
    EstimationActions.update(currentEditingElementDataName, false)
  }
  exitEditingModeIfEnterKey (e) {
    const enter = 13
    if (e.keyCode === enter) {
      this.exitEditingMode()
    }
  }
  changeData () {
    let changedValue = ReactDOM.findDOMNode(this.refs.textbox).value
    // 空文字のみの場合は、値をnullとする(DynamoDBの対策)
    if (changedValue.match(/^[\s:blank:]*$/)) {
      changedValue = null
    }
    // 数値系の場合、記号(マイナスと小数点以外)を除く
    if (changedValue && this.props.isNum) {
      changedValue = changedValue.replace(/[^0-9-.]/g, '')
    }
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      this.props.setListData(listName, index, this.state.bindingDataAttribute, changedValue, this.props.callback)
    } else {
      this.props.setFlatData(this.state.bindingDataAttribute, changedValue, this.props.callback)
    }
  }
  isEditing () {
    const data = EstimationStore.getData()
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      return data[currentEditingElementDataName] === listName + index + this.props.bindingDataAttribute + this.props.viewListId
    }
    return data[currentEditingElementDataName] === this.props.bindingDataAttribute
  }
  getFormattedValue () {
    var result = this.getDataValue()
    if (result === '' || result === null) {
      return '　'
    }

    if (this.props.decimalPlaces > 0) {
      result = Number(result).toFixed(this.props.decimalPlaces)
    }
    if (this.props.isCommaSeparated) {
      result = String(result).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
    if (this.props.prefix) {
      result = this.props.prefix + result
    }
    if (this.props.suffix) {
      result = result + this.props.suffix
    }
    return result
  }
  render () {
    return (
      <div>
        {this.isEditing()
          ? <div>
            <input type='text' ref='textbox' defaultValue={this.getDataValue()} onBlur={this.exitEditingMode.bind(this)} onKeyDown={this.exitEditingModeIfEnterKey.bind(this)}
              onChange={this.changeData.bind(this)}
              autoFocus
              onFocus={function (e) {
                var val = e.target.value
                e.target.value = ''
                e.target.value = val
              }}
              className='kw-w99' style={{margin: 0, padding: 0, textAlign: this.state.textAlign}}
            />
          </div>
        : <div onClick={this.enterEditingMode.bind(this)}
          className='kw-w99'>{this.getFormattedValue()}</div>
        }
      </div>
    )
  }
}

OneLineEditor.defaultProps = {textAlign: 'left', isList: false, isEditable: true, getData: EstimationActions.getCurrentEstimation, setListData: EstimationActions.updateListInCurrentEstimation, setFlatData: EstimationActions.updateCurrentEstimation}
export default OneLineEditor



// WEBPACK FOOTER //
// ./src/company_user/components/OneLineEditor.js